import { toKstDate } from "shared/lib/date/formatKst";

/**
 * 건의 데이터의 기간 필터링과 처리율 계산을 담당하는 훅
 */
export const useSuggests = ({ suggests, startDate, endDate }) => {
  const filteredSuggests = suggests?.filter((suggest) => {
    // createdAt은 서버가 UTC로 생성하므로 KST 보정 후 기간 비교(startDate/endDate는 KST).
    const createdAt = toKstDate(suggest?.createdAt); // 작성일자

    return createdAt && createdAt >= startDate && createdAt <= endDate;
  });

  const waitingCount = suggests?.filter((item) => item.status === 0)?.length; // 대기 중인 건의 글 개수
  const inProgressCount = suggests?.filter((item) => item.status === 1)?.length; // 진행 중인 건의 글 개수

  const suggestPer =
    suggests?.length === 0
      ? 0
      : ((waitingCount + inProgressCount) * 100) / suggests?.length; // 대기 중인 건의와 진행 중인 건의 글의 합

  const suggestPer1 = waitingCount + inProgressCount;

  return { filteredSuggests, suggestPer, suggestPer1 };
};
